import { render, staticRenderFns } from "./PaymentSummary.vue?vue&type=template&id=5a70da6a&scoped=true&"
import script from "./PaymentSummary.vue?vue&type=script&lang=js&"
export * from "./PaymentSummary.vue?vue&type=script&lang=js&"
import style0 from "./PaymentSummary.vue?vue&type=style&index=0&id=5a70da6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a70da6a",
  null
  
)

export default component.exports